import { Translation } from 'types/Translation'

enum LabelType {
  ADMIN_DEFINED = 'ADMIN_DEFINED',
  USER_DEFINED = 'USER_DEFINED',
}

interface Label {
  color: string,
  id: number,
  name: string,
  nameTranslations: Translation[],
  type: LabelType
}

export { LabelType }

export type { Label }
